export const emojiSheetFn = () => 'assets/images/emoji-apple-sheet-64.png';
